<template>
    <el-dialog title="查看失败记录" :visible.sync="dialog.visible" custom-class="table-dialog">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="id" label="编号" width="100"> </el-table-column>
            <el-table-column prop="company" width="160" label="归属公司"> </el-table-column>
            <el-table-column prop="contract_no" width="160" label="合同号"> </el-table-column>
            <el-table-column prop="is_used" label="是否使用" sortable width="160" align="center"> </el-table-column>
            <el-table-column prop="order.hotel_text" label="签单酒店" align="center"> </el-table-column>
            <el-table-column prop="order.create_time" label="使用时间" align="center"> </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.page"
                :page-sizes="[15, 20, 30, 50]"
                :page-size="pagination.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: {
                visible: false
            },
            query: {
                batch_no: ''
            },
            tableData: [],
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            }
        };
    },
    methods: {
        getTableData(batchNo) {
            //获取表格列表
            let that = this;
            let url = '/api/order.contract_no/log';
            let query = this.query;
            this.query.batch_no = batchNo;
            query.pagination = this.pagination;
            this.loading = true;
            this.dialog.visible = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.pagination = result.pagination;
                that.loading = false;
            });
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData(this.query.batch_no);
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData(this.query.batch_no);
        }
    }
};
</script>

<style>
.table-dialog{
    height: 60vh;
    overflow: auto;
}
</style>